import { CanDeactivateFn } from '@angular/router';
import { OnboardDashboardComponent } from './onboard-dashboard.component';

/**
 * Prevents the user from navigating away from the onboarding wizard
 * until all steps are complete (store.isComplete() === true).
 * The success-screen auto-redirect is allowed because it fires after
 * currentStep reaches 4, making isComplete() return true.
 */
export const onboardingGuard: CanDeactivateFn<OnboardDashboardComponent> = (component) => {
  return component.store.isComplete();
};
